var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"el",staticClass:"tag-reference",class:"tag-reference--tail-" + _vm.tailPosition + ' ' + "is-hidden-" + _vm.hideTagReference,style:(_vm.styles),attrs:{"id":_vm.$attrs._id},domProps:{"innerHTML":_vm._s(_vm.$attrs.tagLabel)}})}
var staticRenderFns = []

export { render, staticRenderFns }